<template>
    <div class="mb-5">
        <div class="p-3 my-3 bg-light">
            <strong>クーリエ情報</strong>
        </div>

        <span>発送予定日</span>
        <b-form-datepicker
            v-model="value.shipping_date"
            size="md"
            class="mb-2"
            placeholder=""
            :start-weekday="1"
            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'narrow', }"
            @input="inputDate"
            close-button
            reset-button
            >
        </b-form-datepicker>

        <template v-if="filter_courier !== 'ecms'">
            <span>ペーパレスサービス（ETD・PLT）</span>
            <SelectBase
                v-model="value.plt"
                :options="[
                    { value: true, text: 'ON', },
                    { value: false, text: 'OFF', },
                ]"
                />
            <small class="text-secondary">対応国の場合は、『通関用ラベル』と『インボイス』を電子送信することが可能です。</small>
            <div class="mb-3"></div>
        </template>

        <div class="text-center">
            <b-button size="lg" @click="$refs.plan.fetchRates()">見積計算をする</b-button>
        </div>

        <span>配送プラン選択</span>
        <CourierPlan
            v-model="value.shipping_courier_plan"
            ref="plan"
            @select="onSelect"

            :from="from"
            :to="to"
            :importer="importer"
            :boxes="boxes"
            :items="items"
            :currency="currency"
            :shipping_date="value.shipping_date"
            :plt="value.plt"

            :filter_courier="filter_courier"
            />

        <template v-if="value.shipping_courier_plan">
            <!--
            ===========================================
                DHL
            ===========================================
            -->
            <template v-if="value.shipping_courier_plan.courier === 'dhl'">
                <div class="text-danger mb-3">
                    <div>※危険物は配送できません。</div>
                    <div>※インコタームズはDAPとなります。</div>
                    <div>※クーリエ保険/保証は追加不可能です。</div>
                </div>

                <InvoiceContent
                    v-model="value.shipping_courier_plan.options.dhl_invoice"
                    :signature_default="from.from_representative"
                    />

                <VatContent
                    v-model="value.shipping_courier_plan.options.dhl_vat"
                    :from_country="from.from_country"
                    :to_country="to.to_country"
                    :fields="[ 'fetch', ]"
                    />

            </template>

            <!--
            ===========================================
                Shipper Maker
            ===========================================
            -->
            <template v-if="value.shipping_courier_plan.courier === 'shipper_maker'">
                <div class="text-danger mb-3">
                    <div>※危険物は配送できません。</div>
                </div>

                <div class="p-3 my-3 mt-5 bg-light">
                    <strong>通関書類チェック</strong>
                </div>
                <div
                    v-for="(val, key) in (value.shipping_courier_plan.options.shipper_maker_custom_attributes)"
                    >
                    <b-form-checkbox
                        v-model="value.shipping_courier_plan.options.shipper_maker_custom_attributes[key]"
                        :value="true"
                        :unchecked-value="false"
                        >
                        {{ trans.shipper_maker['custom_attributes.' + key] }}
                    </b-form-checkbox>
                </div>

                <div class="p-3 my-3 mt-5 bg-light">
                    <strong>荷物概要</strong>
                </div>

                <span>Invoice ID</span>
                <b-form-input
                    v-model="value.shipping_courier_plan.options.shipper_maker_invoice_id"
                    type="text"
                    class="mb-3"
                    placeholder=""
                    >
                </b-form-input>

                <span>書類/非書類の選択</span>
                <SelectBase
                    v-model="value.shipping_courier_plan.options.shipper_maker_is_document"
                    :options="[
                        { value: true, text: '書類', },
                        { value: false, text: '非書類', },
                    ]"
                    class="mb-3"
                    />

                <span>従価料金のお支払い</span>
                <SelectBase
                    v-model="value.shipping_courier_plan.options.shipper_maker_is_insured"
                    :options="[
                        { value: true, text: 'お支払いをする', },
                        { value: false, text: 'お支払いをしない', },
                    ]"
                    class="mb-3"
                    />

                <span>関税/消費税の請求先</span>
                <SelectBase
                    v-model="value.shipping_courier_plan.options.shipper_maker_customs_paid_by"
                    :options="[
                        { value: 'shipper', text: '発送国', },
                        { value: 'recipient', text: '受取国', },
                    ]"
                    class="mb-3"
                    />

                <span>輸出の目的</span>
                <SelectBase
                    v-model="value.shipping_courier_plan.options.shipper_maker_purpose"
                    :options="[
                        { value: 'gift', text: '個人的な贈答品', },
                        { value: 'merchandise', text: '商品', },
                        { value: 'sample', text: '商品見本', },
                        { value: 'return', text: '返送', },
                    ]"
                    class="mb-3"
                    />
            </template>
        </template>

        <template v-if="filter_courier === 'ecms'">
            <!--
            ===========================================
                ECMS
            ===========================================
            -->
            <div class="text-right">
                <a class="" href="/manual/ecms" target="_blank">ECMS料金一覧表へのリンクはこちら</a>
            </div>

            <div class="text-danger mb-3">
                <div>※危険物は配送できません。</div>
                <div>※Tuskey保険は追加不可能です。</div>
                <div>※表示されている所要日数は入庫SCAN起算です。天災やストライキ、税関検査など、弊社の責によらない不可抗力が発生した場合はこの限りではありません。また、ホリデーシーズン等の物量が大幅に増える時期には、所要日数が増加する事があります。</div>
            </div>

            <span>貿易取引条件（インコタームズ）</span>
            <SelectBase
                v-model="value.shipping_courier_plan.options.ecms_incoterms"
                :options="[
                    { value: 'EKW', text: 'EKW', },
                    { value: 'FCA', text: 'FCA', },
                    { value: 'FAS', text: 'FAS', },
                    { value: 'FOB', text: 'FOB', },
                    { value: 'CFR', text: 'CFR', },
                    { value: 'CIF', text: 'CIF', },
                    { value: 'CPT', text: 'CPT', },
                    { value: 'CIP', text: 'CIP', },
                    { value: 'DPU', text: 'DPU', },
                    { value: 'DAP', text: 'DAP', },
                    { value: 'DDP', text: 'DDP', },
                ]"
                class="mb-3"
                />

            <span>輸出申告方法</span>
            <SelectBase
                v-model="value.shipping_courier_plan.options.ecms_prefered_export_declaration_entry"
                :options="[
                    { value: 'Formal', text: '一般申告', },
                    { value: 'Informal', text: '簡易通関', },
                ]"
                class="mb-3"
                />

            <span>輸入税支払い</span>
            <SelectBase
                v-model="value.shipping_courier_plan.options.ecms_duties_paid_by"
                :options="[
                    { value: 'Consignee', text: '荷受人払い', },
                    { value: 'Shipper', text: '輸出者払い', },
                ]"
                class="mb-3"
                />

            <span>輸出理由</span>
            <SelectBase
                v-model="value.shipping_courier_plan.options.ecms_export_reason"
                :options="[
                    { value: 'commercial', text: '商業用', },
                ]"
                :options_all="[
                    { value: '贈り物', text: '贈り物', },
                    { value: 'commercial', text: '商業用', },
                    { value: '個人使用', text: '個人使用', },
                    { value: '商品見本', text: '商品見本', },
                    { value: '修理のための返送', text: '修理のための返送', },
                    { value: '修理後の返送', text: '修理後の返送', },
                    { value: '請求', text: '請求', },
                    { value: '発地国に返送', text: '発地国に返送', },
                ]"
                class="mb-3"
                />

            <div class="p-3 my-3 mt-5 bg-light">
                <strong>入庫手続き</strong>
            </div>
            
            <div class="text-secondary mb-3">
                <div>※後で登録または一括登録することが可能です。</div>
            </div>

            <span>搬入業者</span>
            <div class="float-right">
                <span
                    v-for="pickup_courier in [ '日本郵便', 'ヤマト運輸', '佐川急便', '西濃運輸', '福山運輸', ]"
                    >
                    <a
                        href="javascript:void(0)"
                        @click="
                        value.shipping_courier_plan.options.ecms_pickup_courier = pickup_courier;
                        "
                        >
                        {{ pickup_courier }}
                    </a>
                    &nbsp;
                </span>
            </div>
            <b-form-input
                v-model="value.shipping_courier_plan.options.ecms_pickup_courier"
                type="text"
                class="mb-3"
                placeholder=""
                >
            </b-form-input>

            <span>搬入伝票番号</span>
            <b-form-input
                v-model="value.shipping_courier_plan.options.ecms_pickup_waybill_number"
                type="text"
                class="mb-3"
                placeholder=""
                >
            </b-form-input>

        </template>

<!--
        <CourierPlan
            v-model="value.shipping_courier_plan"
            :fields="[ 'fetch', ]"
            />
        <SelectTaxTarget
            v-model="value.shipping_tax_target"
            class="mb-3"
            />

        <template v-if="value.shipping_tax_target">
            <span>登録番号の名称</span>
            <SelectRegistrationNumber
                v-model="value.shipping_tax_name"
                :target="value.shipping_tax_target"
                class="mb-3"
                />

            <span>登録番号</span>
            <b-form-input
                v-model="value.shipping_tax_vat"
                class="mb-3"
                />
        </template>
-->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import InputError from '@/components/InputError.vue'
import GridPage from '@/components/GridPage.vue'
import AddressContent from '@/components/AddressContent.vue'
import LogTable from '@/components/LogTable.vue'
import SelectBase from '@/components/SelectBase.vue'
import CourierPlan from '@/components/CourierPlan.vue'
import InvoiceContent from '@/components/InvoiceContent.vue'
import VatContent from '@/components/VatContent.vue'

export default {
    components: {
        GridPage,
        FormModal,
        ItemBadges,
        AddressContent,
        LogTable,
        SelectBase,
        CourierPlan,
        InputError,

        InvoiceContent,
        VatContent,
    },
    emits: [
        'save',
        'destroy',
    ],
    props: {
        value: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        from: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        to: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        importer: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        boxes: {
            type: Array,
            required: true,
            default() {
                return []
            },
        },
        items: {
            type: Array,
            required: true,
            default() {
                return []
            },
        },
        currency: {
            type: String,
            required: true,
            default() {
                return 'JPY'
            },
        },
        filter_courier: {
            type: String,
            required: false,
            default: '',
        },

    },
    data() {
        return {
            timer: null,
            key: 0,

//            rateOptions: {},
//            data_shipping: {},

        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'auth_level',
            'trans',
        ]),
    },
    mounted() {
//        this.timer = window.setInterval(this.interval, 10 * 1000)
//        this.interval()
    },
    destroyed() {
        clearInterval(this.timer)
    },
    methods: {
        inputDate () {
        },
        onSelect (courier, plan_name, plan_value) {
            this.$utils.set(this.value.shipping_courier_plan, {
                courier: courier,
                plan_name: plan_name,
                plan_value: plan_value,
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.item-name {
    font-size: 1.6em;
    margin-bottom: 0;
}
.item-price {
    font-size: 1.6em;
    margin-bottom: 0;
}
.shipping-address-th {
    width:0.1%;
    white-space: nowrap;
}
</style>

